module.exports = __webpack_public_path__ + "img/Turkey.2bd97832.png";